"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var form_group_with_input_1 = require("../components/form_group_with_input");
var shipping_region_selector_1 = require("./shipping_region_selector");
var shipping_region_1 = require("./shipping_region");
function renderClosed(props) {
    var label = I18n.t('commons.offers.location.shippingTo', {
        regionName: shipping_region_1.shippingRegionName(props.location.shippingRegionCode, props.countries),
        postalCode: props.location.postalCode,
    });
    return (React.createElement("p", { className: "offers-form__location-text" },
        label,
        React.createElement("button", { className: "offers-form__location__edit", onClick: props.onEditLocation }, I18n.t('commons.offers.location.change'))));
}
function renderOpen(props) {
    return (React.createElement("div", { className: "offers-form__location__form" },
        React.createElement("div", { className: "offers-form__location__input" },
            React.createElement(shipping_region_selector_1.default, { countries: props.countries, onChange: props.onLocationChange, value: props.location.shippingRegionCode })),
        React.createElement("div", { className: "offers-form__location__input" },
            React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.offers.location.postalCodeLabel'), fieldName: "postalCode", inputName: "postalCode", value: props.location.postalCode, updateField: props.onLocationChange, required: true }))));
}
var LocationForm = function (props) { return (props.isEditing ? renderOpen(props) : renderClosed(props)); };
exports.default = LocationForm;
//# sourceMappingURL=location_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/location_form.js
// module id = G5TY
// module chunks = 20 21